var map = {
	"./carpenter.jpg": 42966,
	"./construction.jpg": 21115,
	"./glazier.jpg": 1818,
	"./other.jpg": 97820,
	"./seamstress.jpg": 26098,
	"./service.jpg": 51795,
	"./stonemason.jpg": 69039,
	"./upholsterer.jpg": 37687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16467;